<div *ngIf="badges.length; else empty" [class.small]="small" class="badgeRow mt-10">
    <ng-container *ngFor="let badge of badges; let i = index; trackBy: trackByBadge">
        <div *ngIf="!small || i < limit" class="badge flex-space-between d-flex flex-col">
            <div [matTooltipDisabled]="hideTooltip"
                 [matTooltip]="badge.name + (!showInProgress && badge.stack_count > 1? ' earned '+ badge.stack_count + ' times' : '')"
                 class="flex-col align-items-center">
                <strong *ngIf="!small">{{ badge.name }}</strong>
                <div [matBadgeHidden]="showInProgress ||!badge.stack_count || badge.stack_count < 2 "
                     [matTooltipDisabled]="!hideTooltip"
                     [matTooltip]="!showInProgress && badge.stack_count > 1? 'Earned '+ badge.stack_count + ' times' : ''"
                     [matBadge]="badge.stack_count || 0"
                     [matBadgeSize]="small? 'small':'large'"
                     [class.mt-15]="!showInProgress && !small">
                    <img [alt]="badge.name + ' badge'" [src]="badge.image" class="w-100">
                </div>
                <small *ngIf="!small">{{ badge.description }} {{ badge.stack_count }}</small>
            </div>
            <div>
                <div *ngIf="!small && showInProgress" class="customProgress badgeBar">
                    <ng-container *ngFor="let requirement of badge.requirements">
                        <ng-container *ngIf="requirement.quantity > 0 || requirement.updatedQuantity >0 ">
                            <p [style.color]="this.themeService.getReadableColor(community?.badge_progress_slider_bg_color_hex)"
                               class="current">{{ requirement.updatedQuantity || requirement.currentQuantity }}</p>
                            <mat-progress-bar [style.border-color]="community?.badge_progress_slider_bg_color_hex"
                                              [value]="getPercent(requirement.updatedQuantity || requirement.currentQuantity || 0, requirement.quantity)"
                                              class="customProgress customBadgeProgressSlider"
                                              mode="determinate"></mat-progress-bar>
                            <p class="required">{{ requirement.quantity }}</p>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </div>
    </ng-container>
</div>

<ng-template #empty>
    <div class="w-100 flex-row justify-content-center mt-15">
        <div *ngIf="!allBadges.length">This community does not have any badges yet</div>
        <div *ngIf="allBadges.length && showInProgress && !inProgressBadges.length">Congratulations! You have all the
            badges!
        </div>
        <div *ngIf="allBadges.length && !showInProgress && !isMe" class="muted">This user does not have any badges yet
        </div>
        <div *ngIf="allBadges.length && !showInProgress && isMe" class="muted">You don't have any badges yet</div>
    </div>
</ng-template>
